import { State } from '@progress/kendo-data-query';
import { toODataString } from '@progress/kendo-data-query/dist/npm/odata.operators';
import { ODataResponse } from 'src/types/oDataResponse';
import { CHRobinsonLog } from 'src/types/chRobinsonLog';
import { MaxDiscountLog } from 'src/types/maxDiscountLog';
import { MaxDiscountLogUserSummary } from 'src/types/maxDiscountLogUserSummary';
import { MaxDiscountLogItemSummary } from 'src/types/maxDiscountLogItemSummary';
import { get } from './Api';

async function getCHRobinsonLogs(dataState: State): Promise<ODataResponse<CHRobinsonLog>> {
  return get<ODataResponse<CHRobinsonLog>>(`/odata/CHRobinson?${toODataString(dataState, { utcDates: false })}&$count=true`);
}

async function getMaxDiscountLogs(dataState: State): Promise<ODataResponse<MaxDiscountLog>> {
  return get<ODataResponse<MaxDiscountLog>>(`/odata/MaxDiscountLog?${toODataString(dataState, { utcDates: false })}&$count=true`);
}

async function getMaxDiscountLogUserSummary(fromDate: Date, toDate: Date): Promise<MaxDiscountLogUserSummary[]> {
  return get<MaxDiscountLogUserSummary[]>(
    `/MaxDiscountLog/UserSummary?fromDate=${fromDate.toISOString()}&toDate=${toDate.toISOString()}`,
  );
}

async function getMaxDiscountLogItemSummary(fromDate: Date, toDate: Date): Promise<MaxDiscountLogItemSummary[]> {
  return get<MaxDiscountLogItemSummary[]>(
    `/MaxDiscountLog/ItemSummary?fromDate=${fromDate.toISOString()}&toDate=${toDate.toISOString()}`,
  );
}

export default {
  getCHRobinsonLogs,
  getMaxDiscountLogs,
  getMaxDiscountLogUserSummary,
  getMaxDiscountLogItemSummary,
};
